module.exports = __webpack_public_path__ + "media/images/icons/stavyTokuW-3f459d5ae9ca2b3087853e1a8de9c8b9.svg";